const DRAFT_KEY_PREFIX = 'ops-draft-'

export const formDraftKey = (operatorId, resource) => `${DRAFT_KEY_PREFIX}${operatorId}-${resource}-create`

export const readFormDraft = (key) => JSON.parse(window.localStorage.getItem(key))

export const writeFormDraft = (key, snapshot) => window.localStorage.setItem(key, snapshot)

export const removeFormDraft = (key) => window.localStorage.removeItem(key)

export const clearFormDrafts = () =>
  Object.keys(window.localStorage)
    .filter((key) => key.startsWith(DRAFT_KEY_PREFIX))
    .forEach((key) => window.localStorage.removeItem(key))
